import Layout from "@/components/Layout";
import CommunityLibraryPage from "@/pages/CommunityLibraryPage";
import { useTour } from "@reactour/tour";
import { withTour } from "@/components/withTour";
import { useTranslation } from "react-i18next";

const useTourSteps = () => {
  const { t } = useTranslation();
  return [
    {
      selector: '#community-search-sort',
      content: t('communityLibrary.tour.welcome'),
      position: 'bottom',
    },
    {
      selector: '#community-upload-card',
      content: t('communityLibrary.tour.uploadCard'),
      position: 'bottom',
    },
    {
      selector: '#community-channels',
      content: t('communityLibrary.tour.channels'),
      position: 'bottom',
    },
    {
      selector: '#community-video-grid',
      content: t('communityLibrary.tour.videoGrid'),
      position: 'top',
    },
    {
      selector: '#help-button',
      content: t('communityLibrary.tour.helpButton'),
      position: 'bottom',
    },
  ];
};

const CommunityLibraryContent = () => {
  const { setIsOpen, setCurrentStep } = useTour();

  const startTour = () => {
    setCurrentStep(0);
    setIsOpen(true);
  };

  return (
    <Layout onStartTour={startTour}>
      <CommunityLibraryPage />
    </Layout>
  );
};

const CommunityLibraryWrapper = () => {
  const tourSteps = useTourSteps();
  const WrappedComponent = withTour(CommunityLibraryContent, 'autoclipper-community-library-tour-seen', tourSteps);
  return <WrappedComponent />;
};

const CommunityLibrary = CommunityLibraryWrapper;

export default CommunityLibrary;
